/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/Auth/authSlice";
import { useNavigate } from "react-router-dom";
import UserProfileModal from "./UserProfileModal"; // 📦 Imported our new JS profile modal
import mbhcImage from "../../assets/309838218_493827409423554_2856450506263720562_n.jpg";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Local state to manage whether the profile modal is visible
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  // Destructure the new fields we added to the auth slice
  const { user, role, companyId } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  // Helper to get a clean display name
  const displayName = user?.email?.split("@")[0] || "User";

  return (
    <>
      <style>{`
        .profile-trigger {
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .profile-trigger:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15) !important;
          background-color: #dbeafe !important;
        }
        .logout-btn:hover {
          background-color: #fef2f2 !important;
          border-color: #fca5a5 !important;
        }
      `}</style>

      <nav
        className="navbar shadow-sm"
        style={{
          width: "100%",
          height: "60px",
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #e2e8f0",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          padding: "0 1.5rem",
        }}
      >
        <div className="container-fluid d-flex align-items-center">
          {/* BRANDING: Smart HR */}
          <div
            className="d-flex align-items-center gap-2"
            style={{ cursor: "pointer" }}
            // onClick={() => navigate("/")}
          >
<div
        style={{
          width: "32px",
          height: "32px",
          backgroundColor: "#3b82f6",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden", // Ensures the image respects the rounded corners
        }}
      >
        <img
          src={mbhcImage}
          alt="Logo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // Makes sure the image fills the box nicely without distorting
          }}
        />
      </div>
            <span
              className="fw-bold"
              style={{
                letterSpacing: "-0.5px",
                fontSize: "1.25rem",
                color: "#0f172a",
              }}
            >
              HR<span style={{ color: "#3b82f6" }}>IS</span>
            </span>
          </div>

          {/* USER PROFILE & LOGOUT */}
          <div className="ms-auto d-flex align-items-center">
            {user && (
              <>
                {/* Clicking either the text details or avatar opens your modal */}
                <div 
                  className="d-flex flex-column text-end me-3 d-none d-md-block" 
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsProfileOpen(true)}
                >
                  <span
                    className="fw-bold"
                    style={{
                      fontSize: "0.85rem",
                      color: "#1e293b",
                      display: "block",
                      lineHeight: "1.2",
                    }}
                  >
                    {displayName}
                  </span>
                  <span
                    className="text-muted"
                    style={{
                      fontSize: "0.7rem",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    {role}{" "}
                    {user.branch?.branchName ? `• ${user.branch.branchName}` : ""}
                  </span>
                </div>

                {/* Avatar blocks acting as modal view toggle trigger */}
                <div
                  className="profile-trigger shadow-sm"
                  onClick={() => setIsProfileOpen(true)}
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#eff6ff",
                    border: "1px solid #dbeafe",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "15px",
                    color: "#2563eb",
                    fontWeight: "700",
                    fontSize: "0.9rem",
                  }}
                >
                  {user.email?.charAt(0).toUpperCase()}
                </div>
              </>
            )}

            <button
              className="btn btn-sm d-flex align-items-center gap-2 logout-btn"
              onClick={handleLogout}
              style={{
                backgroundColor: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                padding: "6px 15px",
                fontSize: "0.8rem",
                fontWeight: "600",
                color: "#ef4444",
                transition: "all 0.2s ease",
              }}
            >
              <i className="bi bi-box-arrow-right"></i>
              Logout
            </button>
          </div>
        </div>
      </nav>

      {/* 🔐 PROFILE DISPLAY CONTAINER */}
      <UserProfileModal 
        isOpen={isProfileOpen} 
        onClose={() => setIsProfileOpen(false)} 
      />
    </>
  );
};

export default Navbar;